import gmail from '../assets/gmail.png';
import telephonecall from '../assets/telephonecall.png';
import api from '../assets/api.png';
import cprogramming from '../assets/cprogramming.png';
import python from '../assets/python.png';
import react from '../assets/react.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile02 from '../assets/profile02.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';


export default {
  gmail,
  telephonecall,
  api,
  python,
  cprogramming,
  react,
  about01,
  about02,
  about03,
  about04,
  profile02,
  circle,
  logo,
};